define('modules/form_editor/views/editor_custom_separator',['require','exports','module','base/view','ldsh!../templates/editor_custom_separator'],function(require,exports,module){
  "use strict";

  var BaseView = require("base/view");
  module.exports = BaseView.extend({
    template: require("ldsh!../templates/editor_custom_separator"),
    helpers: function () {
      var model = this.model;
      return {
        showHrChecked: model.get("showHr") ? 'checked' : ''
      };
    },
    events: {
      "change .js-element-id, .js-height, .js-hr-width, .js-hr-height, .js-hr-align, .js-show-hr": "updateModel"
    },
    updateModel: function (ev) {
      var model = {
        elementId: this.$(".js-element-id").val().trim(),
        height: parseInt(this.$(".js-height").val().trim(), 10),
        hrWidth: parseInt(this.$(".js-hr-width").val().trim(), 10),
        hrHeight: parseInt(this.$(".js-hr-height").val().trim(), 10),
        hrAlign: this.$(".js-hr-align").val().trim(),
        showHr: this.$(".js-show-hr").is(':checked')
      };
      if (isNaN(model.height)) {
        model.height = this.model.get('height');
      }
      if (model.height < 1) {
        model.height = 1;
      }
      model.hrHeight = Math.min(model.hrHeight, model.height);
      this.model.set(model);
      this.render();
    },
    onRender: function() {
      this.$el.i18n();
    }
  });
});

